import { motion } from 'framer-motion';
import { luxuryEase, viewportOnce } from '../lib/motion';

const steps = [
  {
    n: '01',
    title: 'Keşif',
    text: 'Arazi, ihtiyaç ve yatırım hedefini birlikte netleştiriyoruz.',
  },
  {
    n: '02',
    title: 'Tasarım',
    text: 'Mimari dil, planlar ve malzeme paleti onayınıza sunulur.',
  },
  {
    n: '03',
    title: 'İnşaat',
    text: 'Şantiye sürecini mühendislik kontrolüyle yönetiyoruz.',
  },
  {
    n: '04',
    title: 'Teslim',
    text: 'Anahtar teslim, evrak ve yaşamın başlaması.',
  },
];

export default function Approach() {
  return (
    <section className="bg-nosta-espresso text-white py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ duration: 0.9, ease: luxuryEase }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16"
        >
          <div>
            <p className="eyebrow mb-4">Süreç</p>
            <h2 className="font-display text-4xl md:text-5xl leading-tight max-w-lg">
              Proje nasıl hayata geçer?
            </h2>
          </div>
          <p className="text-white/55 max-w-md leading-relaxed">
            Nosta Yapı’da satış vaadi değil, ölçülebilir bir üretim hattı vardır: keşiften teslime kadar tek muhatap.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {steps.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={viewportOnce}
              transition={{ delay: 0.1 * i, duration: 0.85, ease: luxuryEase }}
              className="bg-nosta-espresso p-8 min-h-[240px] hover:bg-white/[0.04] transition-colors"
            >
              <div className="font-display text-nosta-gold text-2xl mb-8">{step.n}</div>
              <h3 className="font-display text-2xl mb-3">{step.title}</h3>
              <p className="text-white/55 leading-relaxed text-sm">{step.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
